/**
 * Created by Administrador on 20/07/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('disembarkation', {
                parent: 'app',
                url: '/disembarkation',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargo/disembarkation/disembarkation.html',
                        controller: 'disembarkationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoOperationReport('disembarkation')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReport']);
                            }],
                            'branchOffices': ['branchOfficeService', function(branchOfficeService){
                                return branchOfficeService.getBranchOfficesAssociatedAirport(true)
                            }]
                        }
                    }
                }
            });
    }
})();
